import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <h1>Politique de Confidentialité</h1>
      
      <section className="privacy-section">
        <h2>Introduction</h2>
        <p>
          Nous accordons une grande importance à la protection de vos données personnelles. 
          Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Collecte des Données</h2>
        <p>
          Nous collectons les informations suivantes :
        </p>
        <ul>
          <li>Informations de compte (email, nom d'utilisateur)</li>
          <li>Préférences de films et séries</li>
          <li>Notes et commentaires</li>
          <li>Historique de visionnage</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Utilisation des Données</h2>
        <p>
          Vos données sont utilisées pour :
        </p>
        <ul>
          <li>Personnaliser votre expérience</li>
          <li>Générer des recommandations</li>
          <li>Améliorer nos services</li>
          <li>Communiquer avec vous concernant votre compte</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Protection des Données</h2>
        <p>
          Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès, 
          modification, divulgation ou destruction non autorisés.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Partage des Données</h2>
        <p>
          Nous ne vendons pas vos données personnelles à des tiers. Les informations que vous choisissez de 
          rendre publiques (comme les notes et commentaires) sont visibles par les autres utilisateurs de la plateforme.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Vos Droits</h2>
        <p>
          Vous avez le droit de :
        </p>
        <ul>
          <li>Accéder à vos données personnelles</li>
          <li>Rectifier vos données</li>
          <li>Supprimer votre compte</li>
          <li>Exporter vos données</li>
          <li>Vous opposer au traitement de vos données</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Contact</h2>
        <p>
          Pour toute question concernant notre politique de confidentialité ou pour exercer vos droits, 
          vous pouvez nous contacter via le formulaire de support.
        </p>
      </section>

      <div className="footer-links">
        <a href="/support">Support</a>
        <a href="/terms">Conditions d'utilisation</a>
      </div>
    </div>
  );
};

export default Privacy;
